class GreetingCard extends HTMLElement {
  constructor() {
    super()

    // Get all the textarea elements for the greeting card
    this.recipientField = this.querySelector('.sender-name[placeholder="Enter recipient name"]')
    this.senderField = this.querySelector('.sender-name[placeholder="Enter sender name"]')
    this.messageField = this.querySelector('.form-input-placeholder[placeholder="Enter a Message"]')

    // Add event listener to the save button
    this.querySelector("[data-update-note]").addEventListener("click", (event) => {
      this.saveGreetingCard()
    })
  }

  saveGreetingCard() {
    // Get values from all fields
    const recipient = this.recipientField ? this.recipientField.value.trim() : ""
    const sender = this.senderField ? this.senderField.value.trim() : ""
    const message = this.messageField ? this.messageField.value.trim() : ""

    // Format the greeting card data
    let greetingCardNote = ""
    if (recipient || sender || message) {
      greetingCardNote = "GREETING CARD:\n"
      if (recipient) greetingCardNote += `To: ${recipient}\n`
      if (sender) greetingCardNote += `From: ${sender}\n`
      if (message) greetingCardNote += `Message: ${message}\n`
    }

    // Get existing cart note to preserve other notes
    const existingNote = document.querySelector("#Cart-note") ? document.querySelector("#Cart-note").value : ""

    // Remove any existing greeting card data from the note
    const cleanedNote = existingNote.replace(/GREETING CARD:[\s\S]*?(?=\n\n|\n[A-Z]|$)/g, "").trim()

    // Combine existing note with greeting card data
    let finalNote = ""
    if (cleanedNote && greetingCardNote) {
      finalNote = `${cleanedNote}\n\n${greetingCardNote}`
    } else if (cleanedNote) {
      finalNote = cleanedNote
    } else if (greetingCardNote) {
      finalNote = greetingCardNote
    }

    // Update cart note via Shopify API
    const routes = { cart_update_url: "/cart/update" } // Declare the routes variable
    const body = JSON.stringify({ note: finalNote })
    fetch(`${routes.cart_update_url}`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: body,
    })
      .then((response) => {
        if (response.ok) {
          // Update the main cart note field if it exists
          if (document.querySelector("#Cart-note")) {
            document.querySelector("#Cart-note").value = finalNote
          }

          // Close the popup
          this.closePopup()
        }
      })
      .catch((error) => {
        console.error("Error updating greeting card:", error)
      })
  }

  closePopup() {
    // Close the popup and remove active state
    const activePopup = document.querySelector(".popup-toolDown.show")
    if (activePopup) {
      activePopup.classList.remove("show")
    }

    const previewCart = document.querySelector(".previewCart")
    if (previewCart) {
      previewCart.classList.remove("active-tool")
    }
  }
}

// Define the custom element
customElements.define("greeting-card", GreetingCard)


// --------------------------------------------------
class CartTool extends HTMLElement {
  constructor() {
    super();
    const buttons = this.querySelectorAll('.cartTool-item');
    buttons.forEach((button) => {
      button.addEventListener('click',(event) => {
        const id = event.target.dataset.popup;
        document.getElementById(id).classList.add('show');
        document.querySelector('.previewCart').classList.add('active-tool');
      })
    })
  }
}

customElements.define('cart-item-tool', CartTool);

class CartCancel extends HTMLElement {
  constructor() {
    super();
    
    this.querySelector('button').addEventListener('click',(event) => {
      document.querySelector('.popup-toolDown.show').classList.remove('show');
      document.querySelector('.previewCart').classList.remove('active-tool');
    })
  }
}

customElements.define('cart-cancel-popup', CartCancel);

class CartNote extends HTMLElement {
  constructor() {
    super();
    
    this.querySelector('[data-update-note]').addEventListener('click', (event) => {
      this.val = this.querySelector('.text-area').value;
      const body = JSON.stringify({ note: this.val });
      fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
      document.querySelector('.popup-toolDown.show').classList.remove('show');
      document.querySelector('.previewCart').classList.remove('active-tool');
    })
  }
}

customElements.define('cart-note', CartNote);

class CouponCode extends HTMLElement {
  constructor() {
    super();
    if (localStorage.getItem('storedDiscount')){
      this.querySelector('input[name="discount"]').value = localStorage.getItem('storedDiscount');  
    }
    this.querySelector('[data-update-coupon]').addEventListener('click', (event) => {
      this.val = this.querySelector('input[name="discount"]').value;
      localStorage.setItem('storedDiscount', this.val);
      fetch(`/discount/${this.val}`)
          .then((response) => response.text())
          .then((responseText) => {
        	
      });
      document.querySelector('.popup-toolDown.show').classList.remove('show');
      document.querySelector('.previewCart').classList.remove('active-tool');
    })
  }
}

customElements.define('coupon-code', CouponCode);


